import React, { useState, useEffect } from 'react';

import { Grid, TextField, FormGroup, Box, Checkbox, FormControlLabel } from '@mui/material';
import MultiSelectAutocomplete from '../../common/autoComplete/MultiSelectAutocomplete';
import AxiosInstance from '../../../server/AxioInstance';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Button } from '@mui/material';

export const CreateTrainingDialog = ({
  showSnackbar,
  handleCancel,
  fetchTrainingTable,
}) => {
  const [getOptionsUsers, setOptionsUserse] = useState([]);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    login: localStorage.getItem('@gedy:user'),
    date_training: new Date(),
    users: [],
    quiz: false,
    instructors_name: '',
    link_forms: '',
  });

  const handleFormSubmit = async () => {
    showSnackbar({
      vertical: 'top',
      horizontal: 'right',
      message: 'Treinamento criado com sucesso.',
      variant: 'success',
    });
    if (formData.title && formData.date_training && formData.users.length > 0) {
      await AxiosInstance.post('/training/create-training', formData);
      try {
        showSnackbar({
          vertical: 'top',
          horizontal: 'right',
          message: 'Treinamento criado com sucesso.',
          variant: 'success',
        });
        fetchTrainingTable();
        handleCancel();
      } catch (error) {
        showSnackbar({
          vertical: 'top',
          horizontal: 'right',
          message: error.message,
          variant: 'error',
        });
      }
    } else {
      showSnackbar({
        vertical: 'top',
        horizontal: 'right',
        message: 'Por favor, preencha todos os campos obrigatórios.',
        variant: 'warning',
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: checked }));
  };

  const handleChangeUsers = (e, value) => {
    setFormData((prevData) => ({ ...prevData, users: value }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await AxiosInstance.get('/data-input/users');
        setOptionsUserse(result.data);
      } catch (error) {
        showSnackbar({
          vertical: 'top',
          horizontal: 'right',
          message: error.message,
          variant: 'error',
        });
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <DialogTitle>Criar treinamento</DialogTitle>
      <DialogContent>
        <Box p={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                label="Título do Treinamento"
                variant="outlined"
                name="title"
                fullWidth
                margin="normal"
                value={formData.title}
                onChange={handleInputChange}
                required
              />
            </Grid>
            <Grid Grid item xs={12} sm={6} md={6}></Grid>
            <Grid Grid item xs={12} sm={6} md={6}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox name="quiz" checked={formData.quiz} onChange={handleChange} />}
                  label="Esse treinamento precisara de um Teste ?"
                />
              </FormGroup>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                label="Nome do instrutor"
                variant="outlined"
                name="instructors_name"
                fullWidth
                margin="normal"
                color="primary"
                value={formData.instructors_name}
                onChange={handleInputChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                label="Motivo do treinamento"
                variant="outlined"
                name="reason"
                multiline
                rows={4}
                fullWidth
                margin="normal"
                color="primary"
                value={formData.reason}
                onChange={handleInputChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <TextField
                label="Link para o Teste"
                variant="outlined"
                name="link_forms"
                fullWidth
                margin="normal"
                value={formData.link_forms}
                onChange={handleInputChange}
                disabled={!formData.quiz}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                type="datetime-local"
                label="Data do treinamento"
                variant="outlined"
                name="date_training"
                fullWidth
                color="primary"
                required
                value={formData.date_training}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <MultiSelectAutocomplete
                value={formData.users}
                options={getOptionsUsers}
                label="Selecione os participantes"
                onChange={(event, selectValues) => handleChangeUsers(event, selectValues)}
                required={false}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} variant="contained" color="error">
          Cancelar
        </Button>
        <Button onClick={handleFormSubmit} variant="contained" color="success">
          Enviar
        </Button>
      </DialogActions>
    </>
  );
};
